

(function () {
    'use strict';

    // if you're using ag-Grid-Enterprise, you'll need to provide the License Key before doing anything else
    // not necessary if you're just using ag-Grid
    agGrid.LicenseManager.setLicenseKey("Wolverine_World_Wide_MultiApp_1Devs17_May_2018__MTUyNjUxMTYwMDAwMA==c62fecc8cd99255af6d0abb35456b2b9");

    // get ag-Grid to create an Angular module and register the ag-Grid directive
    agGrid.initialiseAgGridWithAngular1(angular);

    angular
        .module('app', ['ui.router',
            'ngCookies',
            'ngMessages',
            'ngDroplet',
            'ngStorage',
            'ngSanitize',
            'angular.filter',
            'ui.bootstrap',
            'toaster',
            //'ngAnimate',
            'angular-loading-bar',
            'cfp.loadingBar',
            'mgcrea.ngStrap',
            //'mgcrea.ngStrap.helpers.dimensions',
            //'ngTouch', /*** odd behavior with mobile tapping/touching ***/
            'adf',
            'adf.structures.base',
            'adf.widget.plm',
            'ncy-angular-breadcrumb',
            'agGrid',
            'ng-currency',
            'gridster',
            'ngVue'
        ])
        .config(config)
        .config(['$compileProvider', function ($compileProvider) {
            //$compileProvider.debugInfoEnabled(false);
        }])
        .config(['$breadcrumbProvider', function ($breadcrumbProvider) {
            $breadcrumbProvider.setOptions({
                templateUrl: templateUrl('app/widgets/angular-breadcrumb/plmTemplate.html')
            });
        }])
        .config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
            cfpLoadingBarProvider.includeSpinner = true;
            cfpLoadingBarProvider.parentSelector = '#wrapper';
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');
            var trident = ua.indexOf('Trident/');
            var edge = ua.indexOf('Edge/');
            var url = window.location.href;

            var loader1 = '<div id="loader"><div class="loading1"><div class="loading-bar accent1"></div><div class="loading-bar accent1"></div><div class="loading-bar accent1"></div><div class="loading-bar accent1"></div></div></div>';
            var loader2 = '<div id="loader"><div class="load-bar"><div class="bar accent2"></div><div class="bar accent3"></div><div class="bar accent4"></div></div></div>';
            var loader3 = '<div id="loader"><div class="loader"></div></div>'; //og loader
            var loaderIE1 = '<div id="loader" class="ie"><img src="Images/loader.gif" /></div>'; //ie gif
            var loaderIE2 = '<div id="loader" class="ie"><img src="Images/loader-ie2.gif" /></div>';

            //if ie
            if (msie > 0 || trident > 0 || edge > 0) {
                cfpLoadingBarProvider.spinnerTemplate = loaderIE2;
            } else {
                cfpLoadingBarProvider.spinnerTemplate = loader1;
            }

            //}
        }])
        .factory('plmThemes', [function () {
            return {
                getThemes: function () {
                    return [
                        { id: 0, name: 'Flat UI (Default)', accent: '', accent2: '', bg: '', mainDark: '', mainLight: '' },
                        { id: 1, name: 'London', accent: '#B31D14', accent2: '#5c0e0a', bg: '#E8E8E8', mainDark: '#043A47', mainLight: '#087891' },
                        { id: 2, name: 'View Over the Town', accent: '#FF5335', accent2: '#cc1f00', bg: '#EFEFEF', mainDark: '#3B424C', mainLight: '#306E73' },
                        { id: 3, name: '1944mustang', accent: '#FF9800', accent2: '#b36b00', bg: '#f1f1f1', mainDark: '#263248', mainLight: '#7E8AA2' },
                        { id: 4, name: 'The Dot Net', accent: '#F1433F', accent2: '#d51310', bg: '#DADADA', mainDark: '#38352C', mainLight: '#3498DB' },
                        { id: 5, name: 'Ripoff', accent: '#3e84d6', accent2: '#284a71', bg: '#dfdfdf', mainDark: '#00786D', mainLight: '#009688' },
                        { id: 6, name: 'Stream In', accent: '#FC4349', accent2: '#fc1d24', bg: '#D7DADB', mainDark: '#2C3E50', mainLight: '#6DBCDB' },
                        { id: 7, name: 'Been Jammin\'', accent: 'rgb(236, 128, 32)', accent2: 'rgb(202, 109, 28)', bg: '#D7DADB', mainDark: 'rgb(18, 97, 119)', mainLight: 'rgb(24,162,201)' },
                        { id: 8, name: 'Bentoo', accent: 'rgb(244, 118, 0)', accent2: 'rgb(215, 76, 0)', bg: '#D7DADB', mainDark: 'rgb(52,136,153)', mainLight: 'rgb(75,181,193)' },
                        { id: 9, name: 'Bending Light', accent: 'rgb(251,120,114)', accent2: '#fa5a52', bg: '#D7DADB', mainDark: 'rgb(34,189,131)', mainLight: 'rgb(120,213,204)' },
                        { id: 10, name: 'Dexter\'s Lab', accent: 'rgb(243, 112, 38)', accent2: 'rgb(210, 96, 32)', bg: '#dddddd', mainDark: 'rgb(32,43,64)', mainLight: 'rgb(146, 185, 89)' }
                    ];
                }
            };
        }])
        .factory('timeConvert', function () {
            return {
                get: function (time, convert) {
                    if (time) {
                        var utc = moment.utc(time).toDate();
                        var local = moment(utc).local().format();
                        return local;
                    }
                }
            }
        })
        .run(run)
        .controller('myTheme', ['$rootScope', '$scope', 'plmThemes', function ($rootScope, $scope, plmThemes) {
            $scope.theme = plmThemes.getThemes();
            $scope.myThemeStyle = $rootScope.globals.currentUser.theme;
            var t = $rootScope.globals.currentUser.theme;
            if (t === "") {
                t = 1;
            }
            $rootScope.accent = $scope.theme[t].accent;
            $rootScope.accent2 = $scope.theme[t].accent2;
            $rootScope.bg = $scope.theme[t].bg;
            $rootScope.mainDark = $scope.theme[t].mainDark;
            $rootScope.mainLight = $scope.theme[t].mainLight;

            $rootScope.statusClass = function (item) {
                var status = item.StatusName || item.CriticalPathHeaderStatusName;
                if (status === "Canceled" || status === "Archive" || status.indexOf("Locked") > -1) {
                    return 'inactive';
                }
            }
        }])
        .controller('StateController', ['$scope', '$state', function ($scope, $state) {
            $scope.$state = $state;
        }])
        .directive('parseStyle', function ($interpolate) {
            return function (scope, elem) {
                var exp = $interpolate(elem.html()),
                    watchFunc = function () { return exp(scope); };

                scope.$watch(watchFunc, function (html) {
                    elem.html(html);
                });
            };
        })
        .directive('formValidation', function () {
            return {
                restrict: 'A',
                link: function (scope, elem) {
                    elem.on('submit', function () {
                        var firstInvalid = elem[0].querySelector('input.ng-invalid');
                        if (firstInvalid) {
                            firstInvalid.focus();
                        }
                    });
                }
            };
        })
        .directive('plmOverflow', ['$timeout', function ($timeout) {
            return {
                restrict: 'A',
                scope: { plmOverflow: '=' },
                link: function (scope, ele, attrs) {
                    var btn = document.createElement('div');
                    btn.className = 'file-tooltip';
                    ele[0].parentNode.insertBefore(btn, ele[0].nextSibling);

                    scope.$watch("plmOverflow", function (newValue, oldValue) {
                        if (!newValue) {
                            if (oldValue)
                                ele[0].innerHTML = '';
                            return;
                        }
                        if (newValue.length > 0) {
                            var newHtml = '<div>' + newValue + '</div>';
                            if (ele[0].children.length > 0) {
                                //assign the text to the child element
                                ele[0].children[0].innerText = newValue;
                                //put the child element with text inside a div
                                newHtml = ele[0].innerHTML;
                            }
                            ele[0].innerHTML = newHtml;
                        }
                    });

                    function overflow(a) {
                        var close = document.createElement('span');
                        close.className = 'overflow-close';
                        close.innerHTML = '&times;';
                        var text = ele[0].innerText;
                        var tooltip = attrs.plmOverflowError ? "<br/><span class='e'>" + attrs.plmOverflow + "</span>" : '';
                        btn.innerHTML = text + tooltip;
                        btn.appendChild(close);

                        var nextSiblingClass = typeof btn.children[1] !== 'undefined' ? btn.children[1].className : '';
                        var e = a.getBoundingClientRect();
                        var pt = window.getComputedStyle(ele[0]).paddingTop !== '0px' ? window.getComputedStyle(ele[0]).paddingTop : window.getComputedStyle(ele[0].parentElement).paddingTop;
                        var pl = window.getComputedStyle(ele[0]).paddingLeft !== '0px' ? window.getComputedStyle(ele[0]).paddingLeft : window.getComputedStyle(ele[0].parentElement).paddingLeft;
                        var t = e.top;
                        var l = e.left;
                        var childWidth = a.children[0] ? a.children[0].clientWidth : a.clientWidth;
                        if (childWidth >= a.clientWidth - 1 || nextSiblingClass == 'e') {
                            btn.setAttribute("style", "top:" + t + "px;left:" + l + "px;padding:" + pt + " " + pl + ";");
                            if (btn.className.indexOf('hover-show') == -1) {
                                btn.className = btn.className + ' hover-show';
                            }
                        }

                        angular.element(close).on('click', function () {
                            var parentOfParent = this.parentNode.previousElementSibling;
                            closeOverflow(parentOfParent);
                        });
                    }

                    function closeOverflow(a) {
                        if (a.className.indexOf('clicked') > -1) {
                            a.className = a.className.replace(' clicked', '');
                            btn.className = btn.className.replace(' selectable', '');
                            btn.className = btn.className.replace('hover-show', '');
                        } else {
                            a.className = a.className + ' clicked';
                            btn.className = btn.className + ' selectable';
                            overflow(a);
                        }
                    }

                    ele.on('mouseover', function () {
                        overflow(this);
                    });

                    ele.on('mouseleave', function () {
                        if (this.className.indexOf('clicked') == -1) {
                            btn.className = btn.className.replace('hover-show', '').trim();
                        }
                    });

                    ele.on('click', function () {
                        closeOverflow(this);
                    });
                }
            };
        }])
        .directive('plmHelp', ['$compile', function ($compile) {
            return {
                link: function (scope, element, attrs) {
                    var icon = '<i class="fa fa-question-circle" aria-hidden="true"></i>';
                    var c = attrs.category;
                    var p = attrs.placement || 'bottom';

                    var tooltips = {
                        "group": 'A group is...',
                        "linePlanRelease": 'A Line Plan must be in Released status in order to be selected.',
                        "briefRelease": 'A brief must be in Released status in order to be selected.'
                    }

                    var tt = $compile('<span class="plm-help" tooltip-placement="' + p + '" uib-tooltip="' + tooltips[c] + '">' + icon + '</span>')(scope);
                    element.append(tt);
                }
            };
        }])
        .directive('recordAvailabilityValidator',
            ['$http', 'WebAPIUrl', function ($http, WebAPIUrl) {
                return {
                    require: 'ngModel',
                    link: function (scope, element, attrs, ngModel) {
                        ngModel.$parsers.push(function (value) {
                            if (!value || value.length === 0) return;

                            ngModel.$setValidity('recordLoading', false);
                            ngModel.$setValidity('recordAvailable', false);
                            ngModel.$setValidity('connectionError', true);

                            $http.get(WebAPIUrl + '/api/Account/UserExists?userName=' + value)
                                .success(function (response) {
                                    if (response === "true") {
                                        ngModel.$setValidity('recordLoading', true);
                                        ngModel.$setValidity('recordAvailable', false);
                                    }
                                    else {
                                        ngModel.$setValidity('recordLoading', true);
                                        ngModel.$setValidity('recordAvailable', true);
                                    }

                                })
                                .error(function () {
                                    ngModel.$setValidity('recordLoading', true);
                                    ngModel.$setValidity('recordAvailable', true);
                                    ngModel.$setValidity('connectionError', false);
                                });
                            return value;
                        });
                    }
                };
            }]
        )
        .directive('systemMessages',
            ["$http", "$timeout", "$q", "$rootScope", "$cookies", "WebAPIUrl", function ($http, $timeout, $q, $rootScope, $cookies, WebAPIUrl) {
                return {
                    //restrict: "E",
                    //transclude: true,
                    link: function (scope, element) {
                        scope.messages = [];
                        $rootScope.versionChange = false;
                        
                        if ($rootScope.systemMessages === undefined)
                            $rootScope.systemMessages = [];

                        var updateTimeoutMilliseconds = moment.duration(10, 'minutes').asMilliseconds();

                        var update = function () {
                            var deferred = $q.defer();

                            $http({
                                method: 'GET',
                                url: WebAPIUrl + "/api/SystemMessage/DisplayMessages",
                                ignoreLoadingBar: true
                            }).success(function (data) {
                                deferred.resolve(data);
                            }).error(function (err, status) {
                                deferred.reject(err, status);
                            });

                            deferred.promise.then(function (response) {
                                angular.forEach(response, function (m, v) {
                                    if (!m.ShowUnauthenticatedUsers && !$rootScope.globals.currentUser)
                                        response.splice(v, 1);
                                });

                                var rL = response.length; //Response Length
                                //systemMessage anti-annoying handling
                                if (rL > 0) {
                                    var getLast = response[rL - 1];
                                    $rootScope.systemMessagesHide = false;
                                    $rootScope.systemMessagesExpire = getLast.ExpireTime;
                                    $rootScope.systemMessagesChanged = getLast.ChangedOn;
                                    var cookie = $cookies.getObject('_systemMessages');
                                    //if cookie exists
                                    if (cookie) {
                                        //if expire is the same as the last message, keep cookie.hide the same, if not, there was a new message, or a new change so we want to show it
                                        $rootScope.systemMessagesHide = cookie.changed == getLast.ChangedOn ? cookie.hide : false;
                                    }

                                    var makeCookie = function (a) {
                                        $cookies.putObject('_systemMessages', {
                                            changed: $rootScope.systemMessagesChanged,
                                            hide: a
                                        }, { 'expires': $rootScope.systemMessagesExpire });
                                    };

                                    makeCookie($rootScope.systemMessagesHide);

                                    $rootScope.systemMessagesDismiss = function () {
                                        makeCookie(true);
                                        $rootScope.systemMessagesHide = true;
                                    };

                                    $rootScope.showSystemMessages = function () {
                                        makeCookie(false);
                                        $rootScope.systemMessagesHide = undefined;
                                    };
                                }

                                $rootScope.systemMessages = response;
                                $timeout(update, updateTimeoutMilliseconds);
                            }, function () {
                                element.empty();
                                $timeout(update, updateTimeoutMilliseconds);
                            });

                        };

                        update();
                    },
                    templateUrl: templateUrl('app/shared/messages/systemMessages.html')
                };
            }]
        )
        .directive('systemAlerts',
            ["$http", "$timeout", "$q", "$rootScope", "WebAPIUrl", function ($http, $timeout, $q, $rootScope, WebAPIUrl) {
                return {
                    templateUrl: templateUrl('app/shared/messages/systemAlerts.html')
                };
            }]
        )
        .directive('version',
            ["$http", "$timeout", "$q", "$rootScope", "WebAPIUrl", function ($http, $timeout, $q, $rootScope, WebAPIUrl) {
                return {
                    templateUrl: templateUrl('app/shared/messages/version.tpl.html')
                };
            }]
        )
        .directive('ngFileDirty', function () {
            return {
                require: '^form',
                transclude: true,
                link: function ($scope, elm, attrs, formCtrl) {
                    elm.on('change', function () {
                        formCtrl.$setDirty();
                        $scope.$apply();
                    });
                }
            };
        })
        .directive('confirmOnExit', ['$rootScope', '$cookies', '$timeout', '$state', function ($rootScope, $cookies, $timeout, $state) {
            return {
                link: function ($scope, elem, attrs) {

                    var properDirty = function () {
                        if ($scope.linePlanCalendersForm && $scope.linePlanCalendersForm.linePlanForm && $state.current.name == 'linePlanEdit') {
                            if (!$scope.linePlanCalendersForm.linePlanForm.$dirty &&
                                !$scope.linePlanCalendersForm.linePlanForm1.$dirty &&
                                !$scope.linePlanCalendersForm.linePlanLaunchForm1.$dirty &&
                                !$scope.linePlanCalendersForm.linePlanSeasonalForm.$dirty &&
                                ($scope.linePlanCalendersForm.tableOptions.$dirty ||
                                    $scope.linePlanCalendersForm.tableOptions2.$dirty)) {
                                return true;
                            }
                        }
                        return false;
                    };

                    //This weird state management code is due to the fact that sometimes
                    //when navigating the $stateChangeStart event fires and sometimes
                    //the $locationChangeStart event fires and sometimes BOTH of them fire.
                    //I couldn't figure out why sometimes both would fire, so in order to
                    //prevent multiple popups, we have to automatically cancel the second one
                    //if the first was cancelled and not show the popup.

                    var userWarned = false;
                    var navigationPrevented = false;

                    var warnUser = function (event) {
                        if (!confirm("There are unsaved changes on the page, do you want to continue without saving?")) {
                            event.preventDefault();
                            navigationPrevented = true;
                        }

                        //Resets the variables after a short timeout - all events should have fired by then.
                        $timeout(function () {
                            userWarned = false;
                            navigationPrevented = false;
                        }, 250);
                    };

                    var preventMessage = function (event) {
                        if (properDirty())
                            return;

                        if ($scope.$eval(attrs.name).$dirty) {
                            $rootScope.cfpLoadingBar.complete();
                            if (navigationPrevented) {
                                event.preventDefault();
                            }
                            else if (!userWarned) {
                                userWarned = true;
                                warnUser(event);
                            }
                        }
                    };

                    var c = $cookies.get('session');
                    if (new Date(c) > new Date()) {

                        window.onbeforeunload = function (a, b, c, d) {
                            if (properDirty())
                                return null;
                            if ($scope.$eval(attrs.name).$dirty) {
                                return "There are unsaved changes on the page, do you want to stay on the page?";
                            }
                        };

                        $scope.$on('$stateChangeStart', function (event, newState, newStateParams) {
                            preventMessage(event);
                        });

                        $scope.$on('$locationChangeStart', function (event, next, current) {
                            preventMessage(event);
                        });
                    }
                }
            };
        }])
        .directive('enter', function () {
            return function (scope, element, attrs) {
                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        event.preventDefault();
                        var fields = $(this).parents('form:eq(0),body').find('input, textarea, select, button, checkbox').not(':disabled');
                        var index = fields.index(this);
                        if (index > -1 && index + 1 < fields.length)
                            fields.eq(index + 1).focus();
                    }
                });
            };
        })
        .directive('onEnter', function () {
            return function (scope, element, attrs) {
                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        event.preventDefault();
                        scope.$apply(function () {
                            scope.$eval(attrs.onEnter);
                        });
                    }
                });
            };
        })
        .directive('nofocus', function () {
            return function (scope, element, attrs) {
                element.bind("focus", function (event) {
                    var fields = $(this).parents('form:eq(0),body').find('input, textarea, select, button, checkbox').not(':disabled');
                    var index = fields.index(this);
                    if (index > -1 && index + 1 < fields.length)
                        fields.eq(index + 1).focus();
                });
            };
        })
        .directive('ctrlEnter', function () {
            return function (scope, element, attrs) {
                element.bind("keydown keypress", function (event) {
                    if (event.which === 10) {
                        event.preventDefault();
                        //close textarea expanded
                        var t = $(element).siblings('.close');
                        plmExpandClose(event, t);
                    }
                });
            };
        })
        .directive('ieTableFix', function ($timeout) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    $timeout(function () {
                        var h = element[0].clientHeight;
                        var e = element[0].getElementsByTagName("input");
                        element[0].style.height = h + "px";
                        for (var i = 0; i < e.length; i++) {
                            e[i].style.height = h + "px";
                        }

                        var s = element[0].getElementsByTagName("select");
                        for (var t = 0; t < s.length; t++) {
                            s[t].style.height = h + "px";
                        }
                    });
                }
            };
        })
        .directive('bsDatepicker', function ($timeout, $window) {
            return {
                restrict: 'A',
                require: 'ngModel',
                //priority: 1,
                link: function (scope, element, attrs, modelCtrl) {

                    var validKeys = /^[0-9]|\/$/g;
                    var forTouched = {};
                    function doWork() {
                        var a = element.val().split('/');
                        for (var i = 0; i < a.length; i++) {
                            if (a[i].length == 1 && !isNaN(a[i])) {
                                a[i] = '0' + a[i];
                            }
                            if (i == 2) {
                                if (a[i].length == 2 && !isNaN(a[i])) {
                                    a[i] = 2000 + parseInt(a[i]);
                                }
                            }
                        }
                        var newVal = a.join().replace(/,/g, '/');
                        element.val(newVal);
                        forTouched.$setViewValue(newVal);
                    }

                    element.on("click", function (event) {
                        $timeout(function () {
                            //var wst = $window.pageYOffset; //window scroll top
                            var t = element[0].getBoundingClientRect().top + element[0].getBoundingClientRect().height; //bottom of element
                            var wh = document.documentElement.clientHeight; //window height
                            //var dp = element.next('.datepicker')[0].getBoundingClientRect().height;

                        });
                    });

                    element.on("focus", function (event) {
                        forTouched = modelCtrl;
                    });

                    element.on('keydown', function (event) {
                        if (element.val().match(validKeys) && event.key == '/') {
                            doWork();
                        }
                    });
                    element.on("blur", function (event) {
                        if (element.val().match(validKeys)) {
                            doWork();
                        }
                        scope.$evalAsync(attrs.ngBlur);
                    });
                }
            };
        })
        .directive('customdateformat', function (dateFilter) {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {

                    var dateFormat = attrs['customdateformat'] || 'yyyy-MM-dd';

                    ctrl.$formatters.unshift(function (modelValue) {
                        return dateFilter(modelValue, dateFormat);
                    });
                }
            };
        })
        .directive('tabFix', function () {
            return {
                "restrict": "A",
                "link": function (scope, element, attrs) {
                    $(element).addClass("tab-fix");
                    $(element).on("keydown", function (e) {
                        if (e.keyCode === 9) {
                            var inputs = $(this).closest("form").find(":input.tab-fix:visible,select.tab-fix:visible");
                            var index = inputs.index(this) + (e.shiftKey ? -1 : 1);
                            if (index > -1 && index < inputs.length) {
                                var nextInput = inputs.eq(index);
                                nextInput.focus();
                                e.preventDefault();
                            }
                        }
                        return true;
                    });
                }
            };
        })
        .directive('headerMargin', [function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {

                    function changeTop() {
                        var h = angular.element(document.querySelectorAll('#header'))[0].getBoundingClientRect().height;
                        var sh = angular.element(document.querySelectorAll('#sub-header'))[0].getBoundingClientRect().height;
                        var margin = h + sh;
                        var parent = element[0].parentNode;
                        parent.style.top = margin + "px";
                    }

                    changeTop();

                    function changeMargin(ele) {
                        var cp = 0;
                        if (scope.headerMargin !== undefined && !scope.headerMargin) {
                            //only calculate if not minimized
                            cp = angular.element(document.querySelectorAll('.cp-row'))[0].getBoundingClientRect().height;
                        };
                        var wrapperContent = angular.element(document.querySelector('#wrapper-content'))[0];
                        wrapperContent.style.marginTop = (scope.headerMargin ? 158 : ele) + cp + "px";
                    };

                    //run the function on load
                    changeMargin(element[0].getBoundingClientRect().height);

                    // Watch for changes on the element height.
                    scope.$watch(function () {
                        return element[0].getBoundingClientRect().height;
                    },
                        function (n, o) {
                            if (n != o) {
                                changeMargin(n);
                            }
                        });

                    // Watch for changes on the cp variable.
                    scope.$watch('headerMargin',
                        function (n, o) {
                            if (n != o) {
                                changeMargin(element[0].getBoundingClientRect().height);
                            }
                        });

                    // Watch for changes on the element height.
                    scope.$watch(function () {
                        return angular.element(document.querySelectorAll('#sub-header'))[0].getBoundingClientRect().height
                    },
                        function (n, o) {
                            changeTop();

                        });
                },
                scope: {
                    headerMargin: '='
                }
            };
        }])
        .directive('wrapperPadding', [function () {
            return {
                link: function (scope, element) {
                    var wrapper = document.getElementById('wrapper');
                    var height = 0;
                    scope.$watch(function () {
                        if (element[0].clientHeight != height) {
                            height = element[0].clientHeight;
                            wrapper.style.paddingTop = element[0].clientHeight - 41 + "px";
                        }
                    });
                }
            };
        }])
        .directive('modalSizeFix', ['$window', '$timeout', '$uibModal', function ($window, $timeout, $uibModal) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    function getSize() {
                        var tables = element[0].querySelectorAll('.table-responsive');
                        angular.forEach(tables, function (t) {
                            var table = angular.element(t);

                            scope.$evalAsync(function () {
                                var wh = $window.innerHeight * 0.8;
                                var mh = element[0].querySelectorAll('.modal-header')[0] ? element[0].querySelectorAll('.modal-header')[0].getBoundingClientRect().height : 0;
                                var ih = element[0].querySelectorAll('.ibox-heading')[0] ? element[0].querySelectorAll('.ibox-heading')[0].getBoundingClientRect().height : 0;
                                var iic = element[0].querySelectorAll('.ibox-item-count')[0] ? element[0].querySelectorAll('.ibox-item-count')[0].getBoundingClientRect().height : 0;
                                var mb = element[0].querySelectorAll('.modal-buttons')[0] ? element[0].querySelectorAll('.modal-buttons')[0].getBoundingClientRect().height : 0;
                                var pager = element[0].querySelectorAll('.sh-pager')[0] ? element[0].querySelectorAll('.sh-pager')[0].getBoundingClientRect().height : 0;

                                table.css({
                                    'height': (wh - (mh + ih + iic + mb + pager)) - 40 + 'px',
                                    'overflow-y': 'auto'
                                });
                            });
                        });
                    }

                    scope.$on("showFavorites", function () {
                        getSize();
                    });

                    scope.$on("searchHelpCompleted", function () {
                        getSize();
                    });

                    angular.element($window).bind('resize', function () {
                        getSize();
                    });

                    $('#searchHelpModalNew .modal-dialog').on('resize', function () {
                        getSize();
                    });

                    $(element).on('shown.bs.modal', function (e) {
                        getSize();
                    });

                }
            };
        }])
        .directive('ddlUpdate', function () {
            return {
                restrict: 'A',
                link: function (scope) {
                    //this watches for a change on the varial in ddl-watch (UI)
                    scope.$watch("ddlWatch", function (newValue, oldValue) {
                        if (typeof newValue == 'undefined') //if data isnt undefined, execute the function defined in ddl-function (UI)
                            return;
                        if (newValue != oldValue)
                            scope.execute();
                    });
                },
                scope: {
                    ddlWatch: "=",
                    execute: '&ddlFunction'
                }
            };
        })
        .directive('ngPageChange', ['$timeout', function ($timeout) {
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: {
                    execute: '&ngPageChange'
                },
                link: function (scope, element, attrs, modelCtrl) {
                    function pageChangeLoaderRemove() {
                        var pcl = document.getElementById("pageChangeLoader");
                        if (pcl) {
                            pcl.parentElement.removeChild(pcl);
                        }
                    }
                    element.bind('keyup', function () {
                        var timer = 900;
                        var ele = element[0].getBoundingClientRect();
                        var t = ele.height + ele.top;
                        var l = ele.left;
                        var w = ele.width;

                        //remove it if it already exists
                        pageChangeLoaderRemove()

                        var v = parseInt(element.val()) || "";
                        var tp = parseInt(attrs.ngTotalpages); //assign total pages from query

                        //if page number is greater, just go to the last page
                        if (v > tp) {
                            v = tp;
                            element.val(v);
                            scope.$apply(function () {
                                modelCtrl.$setViewValue(v);
                            });
                        }

                        //if page number is null dont do anything
                        if (v == "" || v == null) {
                            return;
                        }

                        //create loader bar
                        var timerElement = '<div id="pageChangeLoader" style="width:' + w + 'px;top:' + t + 'px;left:' + l + 'px;"><div style="animation-duration:' + timer + 'ms;"></div></div>';
                        angular.element(document.body).append(timerElement);

                        //cancel timout if it exists
                        $timeout.cancel(scope.executePageChange);

                        scope.executePageChange = $timeout(function () {
                            pageChangeLoaderRemove();
                            scope.execute();
                        }, timer)

                    });
                }
            };
        }])
        .directive('tooltip', function () {
            return {
                restrict: 'A',
                scope: {
                    position: '@tooltip'
                },
                link: function (scope, element, attrs) {
                    $(element).tooltip({
                        delay: { show: 2000, hide: 3000 },
                        tooltipClass: scope.position
                    });
                }
            };
        })
        .directive('resetField', ['$compile', '$timeout', function ($compile, $timeout) {
            return {
                require: 'ngModel',
                scope: {},
                link: function (scope, el, attrs, ctrl) {

                    // limit to input element of specific types
                    var inputTypes = /text|search|tel|url|email|password/i;
                    if (el[0].nodeName !== "INPUT") {
                        throw new Error("resetField is limited to input elements");
                    }
                    if (!inputTypes.test(attrs.type)) {
                        throw new Error("Invalid input type for resetField: " + attrs.type);
                    }

                    // compiled reset icon template
                    var template = $compile('<i ng-show="enabled" ng-click="reset()" class="fa fa-times-circle input-clear"></i>')(scope);
                    el.after(template);

                    scope.reset = function () {
                        ctrl.$setViewValue('');
                        ctrl.$render();
                        $timeout(function () {
                            el[0].focus();
                        }, 0, false);
                    };

                    el.bind('input focus blur', function () {
                        scope.enabled = !ctrl.$isEmpty(el.val());
                        scope.$apply();
                    });
                }
            };
        }])
        .directive("alwaysPristine", function () {
            return {
                restrict: "A",
                require: ["^form", "ngModel"],
                link: function (scope, element, attr, ctrls) {
                    var form = ctrls[0];
                    element.on("focus", function () {
                        scope.isPristine = form.$pristine;
                    });
                    element.on("blur", function () {
                        if (scope.isPristine) {
                            form.$setPristine();
                            form.$setUntouched();
                            scope.$apply();
                        }
                    });
                }
            };
        })
        .directive('mobileTabSelect', function ($timeout) {
            return function (scope, element, attrs) {
                $timeout(function () {
                    $(element).prepend('<div id="navOptions"><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown"><span class="text"></span><span class="menu"><i class="fa fa-chevron-down" aria-hidden="true"></i></span></button><ul class="dropdown-menu"></ul></div></div>');

                    $('.tab-content > div > ul.nav-tabs > li').each(function () {
                        var txt = $(this).find('a').text();
                        var a;

                        if ($(this).is(':first-child')) {
                            $('#navOptions .text').text(txt);
                            a = 'active';
                        } else {
                            a = '';
                        }

                        $('#navOptions .dropdown-menu').append('<li class="' + a + '">' + txt + '</li>');
                    });

                    $(document).on('click touchstart', '#navOptions li', function () {
                        var idx = $(this).index() + 1;
                        var txt = $(this).text();
                        angular.element($('.tab-content > div > ul.nav-tabs > li:nth-child(' + idx + ') a')).triggerHandler('click');
                        $('#navOptions button .text').text(txt);
                        $('#navOptions li').removeClass('active');
                        $(this).addClass('active');
                    });

                    $(document).on('click touchstart', '.tab-content ul.nav-tabs > li a', function () {
                        var txt = $(this).text();
                        var idx = $(this).parent().index() + 1;
                        $('#navOptions button .text').text(txt);
                        $('#navOptions li').removeClass('active');
                        $('#navOptions li:nth-child(' + idx + ')').addClass('active');
                    });

                    $('body')
                        .on('touchstart.dropdown', '.dropdown-menu', function (e) { e.stopPropagation(); })
                        .on('touchstart.dropdown', '.dropdown-submenu', function (e) { e.preventDefault(); });

                });
            };
        })
        .directive("dynamicHeight", function () {
            return {
                restrict: "A",
                link: function (scope, element, attr) {
                    var wh = window.innerHeight - 155;
                    element[0].style = 'min-height:' + wh + 'px';
                    window.addEventListener('resize', function () {
                        element[0].style = 'min-height:' + wh + 'px';
                    }, { passive: true })
                },
                scope: {
                    dynamicHeight: '='
                }
            };
        })
        .directive("dynamicWidth", function ($timeout) {
            return {
                restrict: "A",
                link: function (scope, element, attr) {
                    function newWidth() {
                        $timeout(function () {
                            element[0].style = 'height:' + element[0].clientWidth + 'px';
                        });
                    }

                    newWidth(); //init

                    //change with column resize
                    scope.$watch('dynamicWidth', function (n, o) {
                        newWidth();
                    });

                    //change with window resize
                    window.addEventListener('resize', function () {
                        newWidth();
                    }, { passive: true });
                },
                scope: {
                    dynamicWidth: '='
                }
            };
        })
        .filter('setDecimal', function ($filter) {
            return function (input, places) {
                return parseFloat(Math.round(input * 100) / 100).toFixed(places);
            };
        })
        .filter('percentage', ['$filter', function ($filter) {
            return function (input, decimals) {
                if (isNaN(input)) return "";
                if (input === null) return "";
                if (isNaN(decimals)) decimals = 0;
                return $filter('number')(input, decimals) + ' %';
            };
        }])
        .filter('currencySymbol', [function ($filter) {
            return function (currency) {
                var symbol = currency.CurrencySymbolUnicode
                    ? String.fromCharCode(parseInt(currency.CurrencySymbolUnicode, 16))
                    : currency.CurrencySymbol;

                return symbol ? symbol + " " : "$";
            };
        }])
        .directive('autoFocus', function ($timeout) {
            return {
                restrict: 'AC',
                link: function (_scopescope, _element) {
                    $timeout(function () {
                        _element[0].focus();
                    }, 0);
                }
            };
        });

    config.$inject = ['$stateProvider', '$locationProvider', '$urlRouterProvider', '$httpProvider', '$urlMatcherFactoryProvider'];
    function config($stateProvider, $locationProvider, $urlRouterProvider, $httpProvider, $urlMatcherFactoryProvider) {

        function valToString(val) {
            return val !== null ? val.toString() : val;
        }

        $urlMatcherFactoryProvider.type('nonURIEncoded', {
            encode: valToString,
            decode: valToString,
            is: function () {
                return true;
            }
        });

        $urlRouterProvider.otherwise('/login');
        $stateProvider
            .state('home', {
                url: '/home',
                ncyBreadcrumb: {
                    label: 'Dashboard'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/home/home.tpl.html'),
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('login', {
                url: '/login',
                ncyBreadcrumb: {
                    label: 'Login'
                },
                templateUrl: templateUrl('app/components/login/login.tpl.html'),
                controller: 'LoginController',
                controllerAs: 'vm'
            })
            .state('userList', {
                url: '/users',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> Users'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/userList.tpl.html'),
                        controller: 'UserListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('userAccessReport', {
                url: '/userAccessReport',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> Users'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/userAccessReport.tpl.html'),
                        controller: 'userAccessReportController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('userEdit', {
                url: '/userEdit/:userId',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> Edit User'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/userEdit.tpl.html'),
                        controller: 'UserEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('roleList', {
                url: '/roles',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> Roles'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/roleList.tpl.html'),
                        controller: 'RoleListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('roleEdit', {
                url: '/roleEdit/:roleId',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> Edit Role'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/roleEdit.tpl.html'),
                        controller: 'RoleEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('libraryEntries', {
                url: '/libraryEntries',
                ncyBreadcrumb: {
                    label: 'Library Entries'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/libraryEntries.tpl.html'),
                        controller: 'LibraryEntriesController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('linePlanCreate', {
                url: '/linePlanCreate',
                ncyBreadcrumb: {
                    label: 'Create <i class="fa fa-angle-right" aria-hidden="true"></i> Line Plan'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/linePlan/linePlanCreate.tpl.html'),
                        controller: 'LinePlanCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('linePlanList', {
                url: '/linePlanList',
                ncyBreadcrumb: {
                    label: 'Line Plan <i class="fa fa-angle-right" aria-hidden="true"></i> List'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/linePlan/linePlanList.tpl.html'),
                        controller: 'LinePlanListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('Search', {
                url: '/Search?searchModule&quickSearchText',
                ncyBreadcrumb: {
                    label: 'Search'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/search/search.tpl.html'),
                        controller: 'SearchCtrl',
                    }
                }
            })
            .state('linePlan', {
                url: '/linePlan/:linePlanId',
                ncyBreadcrumb: {
                    label: 'Line Plan <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/linePlan/linePlanEdit.tpl.html'),
                        controller: 'LinePlanEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('linePlanEdit', {
                url: '/linePlanEdit/:linePlanId',
                ncyBreadcrumb: {
                    label: 'Line Plan <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        controller: function ($state, $stateParams) {
                            $state.go('linePlan', {
                                linePlan: $stateParams.linePlanId
                            });
                        },
                    }
                }
            })
            .state('linePlanTemplate', {
                url: '/linePlanTemplate',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> LPC Template <i class="fa fa-angle-right" aria-hidden="true"></i> <span class="ncyBreadcrumbStatic">View</span>'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/corporateTemplate/corporateTemplateView.tpl.html'),
                        controller: 'CorporateTemplateViewController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('linePlanTemplateEdit', {
                url: '/linePlanTemplateEdit',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> LPC Template <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/corporateTemplate/corporateTemplateEdit.tpl.html'),
                        controller: 'CorporateTemplateEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('briefFromLinePlan', {
                url: '/briefFromLinePlan/:linePlanId',
                ncyBreadcrumb: {
                    label: 'Brief <i class="fa fa-angle-right" aria-hidden="true"></i> Create From Line Plan'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/brief/briefCreate.tpl.html'),
                        controller: 'BriefCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('briefCreate', {
                url: '/briefCreate',
                ncyBreadcrumb: {
                    label: 'Create <i class="fa fa-angle-right" aria-hidden="true"></i> Brief'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/brief/briefCreate.tpl.html'),
                        controller: 'BriefCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('briefCopy', {
                url: '/briefCopy/:parentBriefSeasonalId',
                ncyBreadcrumb: {
                    label: 'Brief <i class="fa fa-angle-right" aria-hidden="true"></i> Copy'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/brief/briefCreate.tpl.html'),
                        controller: 'BriefCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('brief', {
                url: '/brief/:briefSeasonalId',
                ncyBreadcrumb: {
                    label: 'Brief <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/brief/briefEdit.tpl.html'),
                        controller: 'BriefEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('briefEdit', {
                url: '/briefEdit/:briefSeasonalId',
                views: {
                    "viewB": {
                        controller: function ($state, $stateParams) {
                            $state.go('brief', {
                                briefSeasonalId: $stateParams.briefSeasonalId
                            });
                        },
                    }
                },
                ncyBreadcrumb: {
                    label: 'Brief <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                }
            })
            .state('patternCreate', {
                url: '/patternCreate',
                ncyBreadcrumb: {
                    label: 'Create <i class="fa fa-angle-right" aria-hidden="true"></i> Pattern'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/pattern/patternCreate.tpl.html'),
                        controller: 'PatternCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('patternCopy', {
                url: '/patternCopy/:parentPatternSeasonalId',
                ncyBreadcrumb: {
                    label: 'Pattern <i class="fa fa-angle-right" aria-hidden="true"></i> Copy'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/pattern/patternCreate.tpl.html'),
                        controller: 'PatternCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('patternFromBrief', {
                url: '/patternFromBrief/:briefSeasonalId',
                ncyBreadcrumb: {
                    label: 'Pattern <i class="fa fa-angle-right" aria-hidden="true"></i> Create from Brief'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/pattern/patternCreate.tpl.html'),
                        controller: 'PatternCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('pattern', {
                url: '/pattern/:patternSeasonalId',
                ncyBreadcrumb: {
                    label: 'Pattern <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/pattern/patternEdit.tpl.html'),
                        controller: 'PatternEditController',
                        controllerAs: 'vm'
                    }
                }
            })

            .state('patternEdit', {
                url: '/patternEdit/:patternSeasonalId',
                views: {
                    "viewB": {
                        controller: function ($state, $stateParams) {
                            $state.go('pattern', {
                                patternSeasonalId: $stateParams.patternSeasonalId
                            });
                        },
                    }
                },
                ncyBreadcrumb: {
                    label: 'Pattern <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                }
            })
            .state('prototypeCopy', {
                url: '/prototypeCopy/:parentPrototypeSeasonalId',
                ncyBreadcrumb: {
                    label: 'Colorway <i class="fa fa-angle-right" aria-hidden="true"></i> Copy'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/prototype/prototypeCreate.tpl.html'),
                        controller: 'PrototypeCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('prototypeCreate', {
                url: '/prototypeCreate',
                ncyBreadcrumb: {
                    label: 'Create <i class="fa fa-angle-right" aria-hidden="true"></i> Colorway'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/prototype/prototypeCreate.tpl.html'),
                        controller: 'PrototypeCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('prototypeFromPattern', {
                ncyBreadcrumb: {
                    label: 'Colorway <i class="fa fa-angle-right" aria-hidden="true"></i> Create from Pattern'
                },
                url: '/prototypeFromPattern/:patternSeasonalId',
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/prototype/prototypeCreate.tpl.html'),
                        controller: 'PrototypeCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('colorway', {
                url: '/colorway/:prototypeSeasonalId',
                ncyBreadcrumb: {
                    label: 'Colorway <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/prototype/prototypeEdit.tpl.html'),
                        controller: 'PrototypeEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('prototypeEdit', {
                url: '/prototypeEdit/:prototypeSeasonalId',
                ncyBreadcrumb: {
                    label: 'Colorway <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        controller: function ($state, $stateParams) {
                            $state.go('colorway', {
                                prototypeSeasonalId: $stateParams.prototypeSeasonalId
                            });
                        },
                    }
                }
            })
            .state('projectCreate', {
                url: '/projectCreate?linePlanId&briefSeasonalId&patternSeasonalId',
                ncyBreadcrumb: {
                    label: 'Create <i class="fa fa-angle-right" aria-hidden="true"></i> Projects'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/project/projectCreate.tpl.html'),
                        controller: 'ProjectCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('projectCreateAny', {
                url: '/projectCreate',
                ncyBreadcrumb: {
                    label: 'Create <i class="fa fa-angle-right" aria-hidden="true"></i> Projects'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/project/projectCreate.tpl.html'),
                        controller: 'ProjectCreateController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('criticalPathDevPatternEdit', {
                url: '/criticalPathDevPatternEdit/:patternSeasonalId',
                ncyBreadcrumb: {
                    label: '<a ui-sref="criticalPath">Critical Path</a> <i class="fa fa-angle-right" aria-hidden="true"></i> Pattern Development<i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/criticalPath/criticalPathDevPatternEdit.tpl.html'),
                        controller: 'CriticalPathDevPatternEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('criticalPathDevPrototypeEdit', {
                url: '/criticalPathDevPrototypeEdit/:devPrototypeId?psid?',
                ncyBreadcrumb: {
                    label: '<a ui-sref="criticalPath">Critical Path</a> <i class="fa fa-angle-right" aria-hidden="true"></i> Colorway Development<i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/criticalPath/criticalPathDevPrototypeEdit.tpl.html'),
                        controller: 'CriticalPathDevPrototypeEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('criticalPathCommercializationEdit', {
                url: '/criticalPathCommercializationEdit/:criticalPathCommercializationId',
                ncyBreadcrumb: {
                    label: '<a ui-sref="criticalPath">Critical Path</a> <i class="fa fa-angle-right" aria-hidden="true"></i> Commercialization <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/criticalPath/criticalPathCommercializationEdit.tpl.html'),
                        controller: 'CriticalPathCommercializationEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('criticalPath', {
                url: '/criticalPath',
                ncyBreadcrumb: {
                    label: 'Critical Path <i class="fa fa-angle-right" aria-hidden="true"></i> Search'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/criticalPath/criticalPathIndex.tpl.html'),
                        controller: 'CriticalPathIndexController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('margin', {
                url: '/margin',
                ncyBreadcrumb: {
                    label: 'Calc <i class="fa fa-angle-right" aria-hidden="true"></i> Margin'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/ELC/margin.tpl.html'),
                        controller: 'MarginController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('fob', {
                url: '/fob',
                ncyBreadcrumb: {
                    label: 'Calc <i class="fa fa-angle-right" aria-hidden="true"></i> FOB'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/ELC/fob.tpl.html'),
                        controller: 'FobController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('register', {
                url: '/register',
                ncyBreadcrumb: {
                    label: 'User <i class="fa fa-angle-right" aria-hidden="true"></i> Register'
                },
                templateUrl: templateUrl('app/components/register/register.tpl.html'),
                controller: 'RegistrationController',
                controllerAs: 'vm'
            })
            .state('displayUserMessage', {
                url: '/displayUserMessage',
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/shared/messages/displayUserMessage.tpl.html'),
                        controller: 'DisplayUserMessageController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('displayMessage', {
                url: '/displayMessage',
                templateUrl: templateUrl('app/shared/messages/displayMessage.tpl.html'),
                controller: 'DisplayMessageController',
                controllerAs: 'vm'
            })
            .state('permissionDenied', {
                url: '/permissionDenied',
                ncyBreadcrumb: {
                    label: 'Permission Denied'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/shared/messages/permissionDenied.tpl.html'),
                        controller: 'PermissionDeniedController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('recordDeleted', {
                url: '/recordDeleted',
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/shared/messages/recordDeleted.tpl.html')
                    }
                }
            })
            .state('errorPage', {
                url: '/errorPage',
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/shared/messages/errorPage.tpl.html')
                    }
                }
            })
            .state('forgotPassword', {
                url: '/forgotPassword',
                ncyBreadcrumb: {
                    label: 'Account <i class="fa fa-angle-right" aria-hidden="true"></i> Forgot Password'
                },
                templateUrl: templateUrl('app/components/managePassword/forgotPassword.tpl.html'),
                controller: 'ManagePasswordController',
                controllerAs: 'vm'
            })
            .state('resetPassword', {
                url: '/resetPassword',
                ncyBreadcrumb: {
                    label: 'Account <i class="fa fa-angle-right" aria-hidden="true"></i> Reset Password'
                },
                templateUrl: templateUrl('app/components/managePassword/resetPassword.tpl.html'),
                controller: 'ResetPasswordController',
                controllerAs: 'vm'
            })
            .state('changePassword', {
                url: '/changePassword',
                ncyBreadcrumb: {
                    label: 'Account <i class="fa fa-angle-right" aria-hidden="true"></i> Change Password'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/managePassword/changePassword.tpl.html'),
                        controller: 'ChangePasswordController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('confirmEmail', {
                url: '/confirmEmail?userIdentification&code:nonURIEncoded',
                ncyBreadcrumb: {
                    label: 'Account <i class="fa fa-angle-right" aria-hidden="true"></i> Confirm Email'
                },
                controller: function (UserService, $scope, $stateParams, $location, $rootScope) {
                    var userData = {
                        userId: $stateParams.userIdentification,
                        code: $stateParams.code
                    };
                    UserService.confirmEmail(userData).then(function (data) {
                        if (data.result === true) {
                            $rootScope.userName = data.userName;
                            $location.path('/changeUserPassword');
                        }
                        else {
                            $rootScope.messageData = {
                                code: "ConfirmEmailError", title: "Confirm Email Error"
                            };
                            $location.path('/displayMessage');
                        }
                    }, function (error, status) {
                        $rootScope.messageData = {
                            code: "ConfirmEmailError", title: "Confirm Email Error"
                        };
                        $location.path('/displayMessage');
                    });

                }
            })
            .state('confirmResetPasswordEmail', {
                url: '/confirmResetPasswordEmail?userIdentification&code:nonURIEncoded',
                controller: function (PasswordService, $scope, $stateParams, $location, $rootScope) {
                    var userData = {
                        userId: $stateParams.userIdentification,
                        code: $stateParams.code
                    };
                    PasswordService.confirmResetPasswordEmail(userData).then(function (data) {
                        if (data.result === true) {
                            $rootScope.code = data.code;
                            $rootScope.userId = data.userId;
                            $location.path('/resetPassword');
                        }
                        else {
                            $rootScope.messageData = {
                                code: "ResetPasswordEmailConfirmationMessage", title: "Confirm Reset Password Email Error"
                            };
                            $location.path('/displayMessage');
                        }
                    }, function (error, status) {
                        $rootScope.messageData = {
                            code: "ResetPasswordEmailConfirmationMessage", title: "Confirm Reset Password Email Error"
                        };
                        $location.path('/displayMessage');
                    });

                }

            })
            .state('UserProfile', {
                url: '/UserProfile',
                ncyBreadcrumb: {
                    label: 'User Profile'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/profile/profileEdit.tpl.html'),
                        controller: 'ProfileEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('flashEditPrototype', {
                url: '/flashEditPrototype',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Flash Edits <i class="fa fa-angle-right" aria-hidden="true"></i> Forecast Flash Edit'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/flashEdit/flashEditPrototype.tpl.html'),
                        controller: 'flashEditPrototype',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('flashEditHTS', {
                url: '/flashEditHTS',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Flash Edits <i class="fa fa-angle-right" aria-hidden="true"></i> Colorway - HTS'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/flashEdit/flashEditHTS.tpl.html'),
                        controller: 'flashEditHTS',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('flashEditPatternForecasting', {
                url: '/flashEditPatternForecasting',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Flash Edits <i class="fa fa-angle-right" aria-hidden="true"></i> Forecasting - Pattern'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/flashEdit/flashEditPatternForecasting.tpl.html'),
                        controller: 'flashEditPatternForecasting',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('flashEditForecasting', {
                url: '/flashEditForecasting',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Flash Edits <i class="fa fa-angle-right" aria-hidden="true"></i> Forecasting - Colorway'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/flashEdit/flashEditForecasting.tpl.html'),
                        controller: 'flashEditForecasting',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('quarterlyForecasting', {
                url: '/quarterlyForecasting',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Quarterly Sales Forecasting'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/quarterlyForecasting/quarterlyForecasting.tpl.html'),
                        controller: 'QuarterlyForecasting',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('transferChecklist', {
                url: '/transferChecklist',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Transfer Checklist'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/transferChecklist/transferChecklist.tpl.html'),
                        controller: 'TransferChecklist',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('quarterlyForecastSettings', {
                url: '/quarterlyForecastSettings',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Quarterly Forecasting Settings'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/quarterlyForecastingSettings.tpl.html'),
                        controller: 'QuarterlyForecastingSettings',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('carryoverConform', {
                url: '/carryoverConform',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Carryover <i class="fa fa-angle-right" aria-hidden="true"></i> Conform'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/carryover/carryoverSelect.tpl.html'),
                        controller: 'carryoverForecasting',
                        controllerAs: 'vm'
                    }
                }
            }).state('carryover', {
                url: '/carryover',
                ncyBreadcrumb: {
                    label: 'Colorway <i class="fa fa-angle-right" aria-hidden="true"></i> Carryover'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/carryover/carryover.tpl.html'),
                        controller: 'coPrototypeSearchController',
                        controllerAs: 'vm'
                    }
                }
            }).state('carryoverFinal', {
                url: '/carryoverFinal',
                ncyBreadcrumb: {
                    label: 'Colorway <i class="fa fa-angle-right" aria-hidden="true"></i> Carryover <i class="fa fa-angle-right" aria-hidden="true"></i> Final'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/carryover/carryoverFinal.tpl.html'),
                        controller: 'carryoverController',
                        controllerAs: 'vm'
                    }
                }
            }).state('flashEditCosting', {
                url: '/flashEditCosting',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Flash Edits <i class="fa fa-angle-right" aria-hidden="true"></i> Colorway - Costing'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/flashEdit/flashEditCosting.tpl.html'),
                        controller: 'flashEditCosting',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('systemMessageList', {
                url: '/systemMessageList',
                ncyBreadcrumb: {
                    label: 'System Messages <i class="fa fa-angle-right" aria-hidden="true"></i> List'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/systemMessages/systemMessageList.tpl.html'),
                        controller: 'SystemMessageListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('migrations', {
                url: '/migrations',
                ncyBreadcrumb: {
                    label: 'DB Migrations <i class="fa fa-angle-right" aria-hidden="true"></i>'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/migrations/migrations.tpl.html'),
                        controller: 'MigrationsController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('systemMessageEdit', {
                url: '/systemMessageEdit/:id',
                ncyBreadcrumb: {
                    label: 'System Messages <i class="fa fa-angle-right" aria-hidden="true"></i> Edit'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/systemMessages/systemMessageEdit.tpl.html'),
                        controller: 'SystemMessageEditController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('errors', {
                url: '/errors',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> Errors'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/errors.tpl.html'),
                        controller: 'ErrorListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('buyreadys', {
                url: '/buyready',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Buy Ready Report'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/buyready.tpl.html'),
                        controller: 'BuyReadyReportController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('buyready', {
                url: '/buyready/:prototypeSeasonalId',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> Buy Ready Report'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/buyready.tpl.html'),
                        controller: 'BuyReadyReportController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('buyreadyoverride', {
                url: '/buyreadyoverride',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> Buy Ready Override'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/admin/buyreadyoverride.tpl.html'),
                        controller: 'BuyReadyOverrideController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('error', {
                url: '/errors/:id',
                ncyBreadcrumb: {
                    label: 'Admin <i class="fa fa-angle-right" aria-hidden="true"></i> Error'
                },
                views: {
                    "viewB": {
                        templateUrl: 'app/components/admin/errors.tpl.html',
                        controller: 'ErrorListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('sitemap', {
                url: '/sitemap',
                ncyBreadcrumb: {
                    label: 'Sitemap'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/sitemap/sitemap.tpl.html'),
                        controller: 'SiteMapController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('help', {
                url: '/help',
                ncyBreadcrumb: {
                    label: 'Help'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/help/help.tpl.html'),
                        controller: 'HelpController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('catalog', {
                url: '/catalog',
                ncyBreadcrumb: {
                    label: 'Catalog'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/catalog/catalog.tpl.html'),
                        controller: 'CatalogController',
                        controllerAs: 'vm'
                    }
                },
                //reloadOnSearch: false
            })
            .state('catalogBrand', {
                url: '/catalog/:pageNumber/:pageSize/:brandId',
                //parent: 'catalog',
                ncyBreadcrumb: {
                    label: '{{breadCrumb}}'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/catalog/catalog.tpl.html'),
                        controller: 'CatalogController',
                        controllerAs: 'vm'
                    }
                },
                //reloadOnSearch: false
            })
            .state('catalogBrandSeason', {
                url: '/catalog/:pageNumber/:pageSize/:brandId/:seasonId',
                //parent: 'catalog.brand',
                ncyBreadcrumb: {
                    label: '{{breadCrumb}}'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/catalog/catalog.tpl.html'),
                        controller: 'CatalogController',
                        controllerAs: 'vm'
                    }
                },
                //reloadOnSearch: false
            })
            .state('catalogBrandSeasonPattern', {
                url: '/catalog/:pageNumber/:pageSize/:brandId/:seasonId/:patternSeasonalId',
                //parent: 'catalog.brand.season',
                ncyBreadcrumb: {
                    label: '{{breadCrumb}}'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/catalog/catalog.tpl.html'),
                        controller: 'CatalogController',
                        controllerAs: 'vm'
                    }
                },
                //reloadOnSearch: false
            })
            .state('patchNotes', {
                url: '/patchNotes',
                ncyBreadcrumb: {
                    label: 'Patch Notes'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/help/patchNotes.tpl.html'),
                        controller: 'PatchNotesController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('uploadQueue', {
                url: '/upload-queue',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Upload Queue <i class="fa fa-angle-right" aria-hidden="true"></i>'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/uploadQueue/uploadQueue.tpl.html'),
                        controller: 'UploadQueueController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('uploadDetails', {
                url: '/upload-queue/:id',
                ncyBreadcrumb: {
                    label: 'Tools <i class="fa fa-angle-right" aria-hidden="true"></i> Upload Queue <i class="fa fa-angle-right" aria-hidden="true"></i> Details'
                },
                views: {
                    "viewB": {
                        templateUrl: templateUrl('app/components/uploadQueue/uploadDetails.tpl.html'),
                        controller: 'UploadDetailsController',
                        controllerAs: 'vm'
                    }
                }
            });
        //save for future use of the removal of # in the url
        $locationProvider.html5Mode(true);

        // Use x-www-form-urlencoded Content-Type
        $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
        $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';

        // Override $http service's default transformRequest
        $httpProvider.defaults.transformRequest = [function (data) {
            /**
            * The workhorse; converts an object to x-www-form-urlencoded serialization.
            * @param {Object} obj
            * @return {String}
            */
            var param = function (obj) {
                var query = '';
                var name, value, fullSubName, subName, subValue, innerObj, i;

                for (name in obj) {
                    value = obj[name];

                    if (value instanceof Array) {
                        for (i = 0; i < value.length; ++i) {
                            subValue = value[i];
                            fullSubName = name + '[' + i + ']';
                            innerObj = {
                            };
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + '&';
                        }
                    }
                    else if (value instanceof Object) {
                        for (subName in value) {
                            subValue = value[subName];
                            fullSubName = name + '[' + subName + ']';
                            innerObj = {
                            };
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + '&';
                        }
                    }
                    else if (value !== undefined && value !== null) {
                        query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
                    }
                }

                return query.length ? query.substr(0, query.length - 1) : query;
            };

            return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
        }];

    }

    run.$inject = ['$rootScope', '$state', '$location', '$cookies', '$http', '$localStorage', '$timeout', '$interval', '$window', '$parse', '$filter',
        'AuthenticationService', 'toaster', 'UserPreferenceService', 'cfpLoadingBar', 'timeConvert'];
    function run($rootScope, $state, $location, $cookies, $http, $localStorage, $timeout, $interval, $window, $parse, $filter,
        AuthenticationService, toaster, UserPreferenceService, cfpLoadingBar, timeConvert) {
        var timeoutClear;

        $rootScope.isActiveState = function (statename) {
            return $state.current.name == statename ? true : false;
        };

        $rootScope.globals = {};

        $rootScope.altInputFormats = ['M!/d!/yyyy', 'M!/d!/yy', 'shortDate'];
        $rootScope.dateOptions = {
            showWeeks: false,
            appendToBody: true
        };

        $rootScope.logout = function (disconnect) {
            AuthenticationService.clearCredentials();
            if (!disconnect) {
                $rootScope.sessionEnd = true;
            }
            $state.go('login');
        };

        $rootScope.disconnectModal = function (show) {
            if (show) $('#disconnectModal').modal('show');
            else $('#disconnectModal').modal('hide');
        };

        //for use in templates
        $rootScope.timeConvert = timeConvert;
        //for use on confirmOnExit directive
        $rootScope.cfpLoadingBar = cfpLoadingBar;

        $rootScope.hideBusyWait = function () {
            window.setTimeout(function () {
                cfpLoadingBar.complete();
            }, 0);
        };

        var reminderStart, reminderCountdown;
        $rootScope.sessionCheck = function (event, toState) {
            $timeout.cancel(reminderStart);
            $interval.cancel(reminderCountdown);
           
            //if (typeof $rootScope.globals.currentUser !== 'undefined') {
            //    //if cookie session exists, refresh it, if it doesnt, log user out
            //    var c = $cookies.get('session');
            //    console.log("rootScoppe.global.currentUser", typeof $rootScope.globals.currentUser);
            //    if (new Date(c) > new Date()) {
            //        //session expire times     
            //        var sessionExpireUnits = 3; //hours, minutes, seconds (defined below)
            //        var sessionReminderUnits = 25; //hours, minutes, seconds (defined below)
            //        var sessionExpire = moment().local().add(sessionExpireUnits, 'hours').format();
            //        var sessionTime = moment.duration(sessionExpireUnits, 'hours').asMilliseconds();
            //        var sessionReminder = moment.duration(sessionReminderUnits, 'minutes').asMilliseconds();
            //        //session recreate with expiration added    
            //        $cookies.put('session', new Date(sessionExpire));

            //        function countdown() {                        
            //            var duration = moment.duration(new Date(sessionExpire) - new Date(), 'milliseconds');
            //            var h = duration.hours() !== 0 ? duration.hours() + " hours, " : "";
            //            var m = duration.minutes() !== 0 ? duration.minutes() + " minutes, " : "";
            //            var s = duration.seconds() ? duration.seconds() + " seconds." : " 0 seconds.";

            //            if (duration > 0) {
                           
            //                $rootScope.timeLeft = h + m + s;
            //            } else {
            //                $('#sessionModal').modal('hide');
            //                $interval.cancel(reminderCountdown);
            //                //rerun function to make it logout
            //                $rootScope.logout();
            //            }
            //        }

            //        reminderStart = $timeout(function () {
                        
            //            $('#sessionModal').modal('show');
            //            reminderCountdown = $interval(function () {
            //                countdown();
            //            }, 1000);
            //            countdown(); //run it first so it shows the time
            //        }, sessionTime - sessionReminder);

            //    } else {
            //        event.preventDefault();
            //        $rootScope.logout();
            //    }
            //} 
        };

        $rootScope.refreshLogin = function (user) {

            if (typeof user === 'undefined') {
                user = $localStorage.currentUser;
            }
                              
            if (!user || !user.refreshToken) {
                return;
            }

            AuthenticationService
                .refreshLogin(user.refreshToken)
                .then(function (data) {
                    AuthenticationService.setCredentials(data);

                    $rootScope.brandPermissions = JSON.parse(data.brands);
                    $rootScope.userPermissions = JSON.parse(data.permissions);
                    $rootScope.isFactoryUser = data.isFactoryUser === 'True';

                }, function (err) {
                    AuthenticationService.clearCredentials();

                    if (err.error === "role_not_assigned") {
                        $rootScope.messageData = {
                            code: "RoleNotAssigned", title: "Account Issue"
                        };
                        $state.go('displayMessage');
                    }
                    else if (err.error === "confirm_email") {
                        $rootScope.messageData = {
                            code: "ConfirmEmail", title: "Confirm Email"
                        };
                        $state.go('displayMessage');
                    }
                    else if (err.error === "change_password_required") {
                        $rootScope.userName = user.userName;
                        $state.go('changeUserPassword');
                    }
                    else {
                        $location.path('/login');
                    }
                });

            if ($location.path() === "/login") {
                $location.path('/home');
            }
            else {
                $location.path();
            }
        }

        // keep user logged in after page refresh
        var currentUser = $localStorage.currentUser;
        var c = $cookies.get('session');
        if (currentUser && (new Date(c) > new Date())) {
            $rootScope.currentUser = currentUser;
            $rootScope.userId = currentUser.userId;
            $rootScope.userName = currentUser.userName;
            $rootScope.fullName = currentUser.firstName + ' ' + currentUser.lastName;
            $rootScope.theme = currentUser.theme;
            $rootScope.brandPermissions = currentUser.brandPermissions;
            $rootScope.userPermissions = currentUser.userPermissions;

            $rootScope.globals.currentUser = currentUser;

            $rootScope.refreshLogin();

            //get current user details
            if ($rootScope.globals.currentUser) {
                $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.accessToken;
            }
        }

        //will show on state change (page change)
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, element) {
            var formTouched = sessionStorage.getItem('formTouched');
            if (formTouched == "true") {
                if (!confirm("There are unsaved changes on the page, do you want to continue without saving?")) {
                    event.preventDefault();
                    return false;
                }
            }
            
            sessionStorage.setItem('stateChange', true);
            sessionStorage.removeItem('formTouched');
            //$rootScope.sessionCheck(event, toState);
            cfpLoadingBar.start();
            
        });

        $rootScope.$on('$stateChangeComplete', function (event, toState, toParams, fromState, fromParams, element) {
            //$rootScope.sessionCheck(event, toState);
        });

        $rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams, element) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        });

        //Get local storage values for the session
        if ($localStorage.changePasswordUserName) {
            $rootScope.userName = $localStorage.changePasswordUserName;
        }

        if ($localStorage.messageData) {
            $rootScope.messageData = $localStorage.messageData;
        }

        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            // redirect to login page if not logged in and trying to access a restricted page
            var currentUser = $localStorage.currentUser;

            var loggedIn = false;

            var c = $cookies.get('session');
            if (currentUser && (new Date(c) > new Date())) {
                loggedIn = moment().diff(currentUser.validUntil) < 0;

                $rootScope.currentUser = currentUser;
                $rootScope.userId = currentUser.userId;
                $rootScope.userName = currentUser.userName;
                $rootScope.fullName = currentUser.firstName + ' ' + currentUser.lastName;
                $rootScope.theme = currentUser.theme;

                $rootScope.brandPermissions = currentUser.brandPermissions;
                $rootScope.userPermissions = currentUser.userPermissions;

                $rootScope.globals.currentUser = currentUser;
            }

            var restrictedPageList = ['/login', '/register', '/forgotPassword', '/forgotPasswordMessage', '/resetPassword', '/confirmResetPasswordEmail', '/displayMessage', '/confirmEmail', '/changeUserPassword'];
            var restrictedPage = restrictedPageList.indexOf($location.path()) === -1;

            if (!loggedIn) {
                //if not on a restricted page and not login
                if (restrictedPage) {
                    //if not logged in and location path isnt login, then send them to the login page
                    if ($location.path() !== '/login') {
                        $rootScope.redirectURL = $location.path();
                        $location.path('/login');
                    };
                }
            } else {
                //if logged in and you access these pages, go to /home - instead of a blank page
                if (restrictedPageList.indexOf($location.path()) > -1) {
                    $location.path('/home');
                }
            }
        });

        document.addEventListener("keydown", function (e) {
            if (e.ctrlKey && e.shiftKey && e.code === "KeyE") {
                var errorPageAccess = false;
                angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
                    if (userPermissionRow[0] === 6) {
                        errorPageAccess = true;
                    }
                });
                if (errorPageAccess) {
                    window.open(window.location.origin + '/errors');
                }
            }
        });

        //assign plmVersion from head in Index.cshtml
        $rootScope.plmVersion = window.plmVersion;
        var date = $rootScope.plmVersion.deploymentDate;

        //if (date !== "") {
        //    date = new Date(date);
        //    $rootScope.plmVersion.deploymentDate = $filter('date')(date, 'MM/dd/yy h:mma');
        //}
    }
})();
